/**
 * Axios 拦截器配置
 */
import { Message } from 'element-ui'
import router from '@/router'
import qs from 'qs'
import { SUCCESS_CODES } from './config'

// 请求拦截器
export function requestInterceptor(config) {
  // 添加 token 到请求头
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['token'] = token
  }

  // POST 请求转换为 form-data
  if (
    config.method === 'post' &&
    config.data &&
    typeof config.data === 'object'
  ) {
    config.data = qs.stringify(config.data)
  }

  return config
}

// 请求错误处理
export function requestErrorInterceptor(error) {
  return Promise.reject(error)
}

// 响应拦截器
export function responseInterceptor(response) {
  const res = response.data

  // 如果是 blob 类型响应（文件下载），直接返回 response
  if (response.config.responseType === 'blob') {
    return response
  }

  // 判断成功状态码
  if (!SUCCESS_CODES.includes(res.code)) {
    handleErrorCode(res)
    return Promise.reject(new Error(res.message || res.msg || '请求失败'))
  }

  // 返回 data 数据（如果 data 有值），否则返回整个响应
  return res.data != null ? res.data : res
}

// 响应错误处理
export function responseErrorInterceptor(error) {
  let message = '请求失败'

  // 处理 HTTP 401 状态码（未授权）
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('token')
    // 判断是否是超级管理员，跳转到对应登录页
    if (parseInt(localStorage.getItem('userType')) === 2) {
      router.push('/login/super-admin')
    } else {
      router.push('/login')
    }
    Message.error('登录已过期，请重新登录')
    return Promise.reject(error)
  }

  if (error.message.includes('timeout')) {
    message = '请求超时，请检查网络'
  } else if (error.message.includes('Network Error')) {
    message = '网络错误，请检查网络连接'
  }

  Message.error(message)
  return Promise.reject(error)
}

// 处理错误状态码
function handleErrorCode(res) {
  const message = res.message || res.msg || '请求失败'

  switch (res.code) {
    case 401:
      localStorage.removeItem('token')
      // 判断是否是超级管理员，跳转到对应登录页
      if (parseInt(localStorage.getItem('userType')) === 2) {
        router.push('/login/super-admin')
      } else {
        router.push('/login')
      }
      Message.error('登录已过期，请重新登录')
      break
    case 403:
      Message.error('没有权限访问')
      break
    case 404:
      Message.error('请求的资源不存在')
      break
    case 500:
      Message.error('服务器错误，请稍后重试')
      break
    default:
      Message.error(message)
  }
}
